/**
 * 优惠券间隔
 */
import React from 'react';

import styles from './index.module.scss';

const Index: React.FC<{ text: React.ReactNode }> = (props) => {
  return <div className={styles.couponGapText}>{props.text}</div>;
};

export default Index;
